import { Modal } from "react-bootstrap";

const NoteModal = ({
    show,
    setShow,
    note
}: {show: boolean, setShow: (arg0: boolean) => void, note: string}) => {
    return (
        <Modal centered show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Note from Vendor</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {note}
            </Modal.Body>
        </Modal>
    );
}

export default NoteModal;
